module.exports = __webpack_public_path__ + "static/media/poste_30.5dd15036.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/poste_30.jpg
// module id = 260
// module chunks = 0